import { render, staticRenderFns } from "./create-product-action.vue?vue&type=template&id=15a7e29c"
import script from "./create-product-action.ts?vue&type=script&lang=js&external"
export * from "./create-product-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports